import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthKey } from "../components/header";
import VPlogo from "../assets/logo-black.png"
import { productList } from "../components/productList";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { AdminKey } from "../components/header";

import "./packingslip.scss";

export default function PackingSlip() {
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(useLocation().search);
    const orderId = searchParams?.get('orderId');
    const adminKey = searchParams?.get('zxcv');
    const [order, setOrder] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if the user is an admin
        if (adminKey !== AdminKey)
            navigate('/');

        async function getOrder() {
            // Call the lambda to get the order
            await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/getOrder?orderId=" + orderId + "&marker=" + AuthKey, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: '',
            })
            .then((res) => res.json())
            .then((data) => {
                setOrder(data);
                setLoading(false);
            });
        }
        if (loading) {
            getOrder();
        }
    }, [order, loading, orderId, adminKey, navigate]);
    
    return (adminKey === AdminKey && <HelmetProvider><Helmet title="Packing Slip"/>
        <div style={{ margin: '0px', padding: 32, fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
            <h2>Packing Slip</h2>
            <hr />
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tr>
                    <td style={{ padding: '8px', verticalAlign: 'top' }}>
                        <img src={VPlogo} alt="Logo" style={{ width: '180px' }} />
                    </td>
                    <td style={{ paddingRight: '200px'}}></td>
                    <td style={{ padding: '8px', verticalAlign: 'middle' }}>
                        <strong>Order Number:</strong> {orderId ? orderId : <em>Not provided</em>}<br />
                    </td>
                </tr>
                <tr>
                    <td style={{ padding: '8px', verticalAlign: 'top' }}>
                        {/* <strong>Customer:</strong>order?.name<br /> */}
                        {order?.customer?.name}<br />
                        {order?.customer?.addressLine1}<br />
                        {order?.customer?.addressLine2 !== '' && <span>{order?.customer?.addressLine2}<br /></span>}
                        {order?.customer?.city}, {order?.customer?.state} {order?.customer?.zip}<br />
                    </td>
                    <td></td>
                    <td style={{ padding: '8px', verticalAlign: 'top' }}>
                        Order date: {new Date(order?.orderDate).toLocaleDateString()}
                    </td>
                </tr>
            </table>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tr>
                    <td style={{ padding: "20px 0 0 20px"}}><strong>Qty</strong></td>
                    <td style={{ padding: "20px 0 0 0"}}><strong>Item</strong></td>
                    <td style={{ padding: "20px 0 0 0"}}><strong>Price</strong></td>
                </tr>
                {order?.items?.map((item, index) => {
                    return (
                    <tr>
                        <td style={{ padding: "8px 0 0 25px"}}>{item.quantity}</td>
                        <td style={{ padding: "8px 0 0 0"}}>{productList.filter(p => p.ProductID === item.productId)[0]?.Title}</td>
                        <td style={{ padding: "8px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.unitPrice / 100)}</td>
                    </tr>)})}
                <tr>
                    <td></td>
                    <td style={{ padding: "15px 0 0 0"}}><strong>Tax</strong></td>
                    <td style={{ padding: "15px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.tax / 100)}</td>
                </tr>
                <tr>
                    <td></td>
                    <td style={{ padding: "6px 0 0 0"}}><strong>Shipping & handling</strong></td>
                    <td style={{ padding: "6px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.sandh / 100)}</td>
                </tr>
                <tr>
                    <td></td>
                    <td style={{ padding: "12px 0 0 0"}}><strong>Total</strong></td>
                    <td style={{ padding: "12px 0 0 0"}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order?.total / 100)}</td>
                </tr>
            </table>
            <br />
            <br />
            <br />
            <h3>Thank you for your order!</h3>
            <p>If you have any questions, please contact us at <a href="mailto:support@veritypublishing.com">support@veritypublishing.com</a></p>
        </div>
    </HelmetProvider>);
}

